import React from "react";
import { SignIn } from "../../../../components";
function AdminLogin() {
  return <SignIn isAdminLogin={true} />;
}

export default AdminLogin;
